<template>
    <div class="fitbase-login_form">
        {{ form.info }}
        <div class="fitbase-login_form--phone" v-if="activeForm === 'phone'">
            <form @submit.prevent="sendPhone">
                <vue-tel-input
                    :key="defaultCountry"
                    v-model="phoneInputRaw"
                    class="fitbase-login_form--phone-input rad-8"
                    :default-country="defaultCountry"
                    :preferred-countries="preferredCountries"
                    :input-options="phoneInputOptions"
                    @validate="onPhoneValidate"
                    @on-input="(value, phone) => onPhoneValidate(phone)"
                    @country-changed="onPhoneCountryChanged"
                />
                <button
                    type="submit"
                    class="btn btn-full rad-8"
                    :class="{disabled: isDisabledBtn || !phoneValid}"
                    :disabled="isDisabledBtn || !phoneValid"
                >
                    Продолжить
                </button>

                <div class="fitbase-login_form--agree">
                    <span>Продолжая, вы даёте </span>
                    <a
                      v-if="agreeParts.consent.href"
                      :href="agreeParts.consent.href"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {{ agreeParts.consent.label }}
                    </a>
                    <span v-else>{{ agreeParts.consent.label }}</span>
                    <span> на </span>
                    <a
                      v-if="agreeParts.personalData.href"
                      :href="agreeParts.personalData.href"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {{ agreeParts.personalData.label }}
                    </a>
                    <span v-else>{{ agreeParts.personalData.label }}</span>
                    <span>. Соглашаетесь с </span>
                    <a
                      v-if="agreeParts.offer.href"
                      :href="agreeParts.offer.href"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {{ agreeParts.offer.label }}
                    </a>
                    <span v-else>{{ agreeParts.offer.label }}</span>
                    <span>, </span>
                    <a
                      v-if="agreeParts.clubRules.href"
                      :href="agreeParts.clubRules.href"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {{ agreeParts.clubRules.label }}
                    </a>
                    <span v-else>{{ agreeParts.clubRules.label }}</span>
                    <span>.</span>
                </div>
            </form>
        </div>

        <div class="fitbase-login_form--code" v-if="activeForm === 'code'">
            <form v-if="activeAuthType === 'sms' || activeAuthType === 'call_password' || activeAuthType === 'whatsapp'" @submit.prevent="checkAuth">
                <div class="hint fitbase-code-hint">
                    <p class="fitbase-code-hint__title">{{ codeHint }}</p>
                    <b class="fitbase-code-hint__notice">{{ phoneNoticeText }}</b>
                </div>
                <div class="fitbase-code_inputs">
                    <split-input
                        v-model="form.code"
                        class-name="code_input"
                        :input-number="4"
                        type="tel"
                    />
                </div>
                <button
                    class="btn btn-full rad-8"
                    :class="{disabled: this.form.code.toString().length !== 4 || isDisabledBtn === true}"
                    :disabled="this.form.code.toString().length !== 4 || isDisabledBtn === true"
                >
                    Продолжить
                </button>
                <div class="hint fitbase-login_form--send-again">
                    <p v-if="send_again === false">Повторная отправка через: {{ timer }} сек</p>
                    <p v-if="send_again === true" @click="resendCode" class="main-color"><b>Отправить код повторно</b></p>
                </div>
            </form>
            <div v-if="activeAuthType === 'call_gate'">
              <div class="hint">
                <p>Для входа совершите бесплатный звонок на номер</p>
                <b>{{ phoneToCall }}</b>
              </div>
              <a :href="'tel:' + phoneToCall" class="btn btn-full">
                Позвонить
              </a>
              <div class="hint fitbase-call-gate-check">
                <p>Ничего не произошло?</p>
                <a @click="checkAuth" class="main-color"><b>Проверить сессию</b></a>
              </div>
            </div>
            <div v-if="isBotAuthType">
              <template v-if="!botWaiting">
                <a
                  v-for="bot in bots"
                  :key="bot.type"
                  :href="bot.link"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="btn btn-full fitbase-bot-login-btn"
                  @click="onBotLoginClick"
                >
                  <img :src="botAuthConfig(bot.type).icon" alt="">
                  <span>{{ botAuthConfig(bot.type).loginLabel }}</span>
                </a>
              </template>
              <div v-else class="fitbase-tgb-waiting">
                <span class="fitbase-loader loader-spin"></span>
                <p class="fitbase-tgb-waiting__title">Ожидаем подтверждения...</p>
                <p class="fitbase-tgb-waiting__text">Пожалуйста, перейдите в выбранное приложение и подтвердите вход</p>
              </div>
            </div>
            <div class="hint fitbase-login_form--choose-another-method">
              <a @click="chooseAnotherMethod" class="main-color"><b>Выбрать другой способ входа</b></a>
            </div>
        </div>

        <div class="fitbase-login_form--registration" v-if="activeForm === 'registration'">
            <form @submit.prevent="handleRegistrationStep">
                <input
                    placeholder="Имя"
                    v-model="form.name"
                >
                <input
                    placeholder="Фамилия"
                    v-model="form.surname"
                >
                <Datepicker
                        v-model="form.birth_date"
                        modelType="yyyy-MM-dd"
                        placeholder="Дата рождения"
                        format="dd.MM.yyyy"
                        locale="ru"
                        cancelText=""
                        selectText="Применить"
                        :enableTimePicker="false"
                        :disabledDates="(date) => date >= new Date()"
                >
                </Datepicker>

                <button
                    class="btn btn-full"
                    :class="{disabled: isDisabledBtn}"
                    v-text="form.club_id || clubs.length <= 1 ? 'Зарегистрироваться' : 'Далее'"
                >
                </button>
            </form>
        </div>

        <div class="fitbase-login_form--club" v-if="activeForm === 'club'">
            <ClubList
                :clubs="clubs"
                empty-text="Клубы не найдены"
                @select-club-id="form.club_id = $event"
                :selectedClubId="form.club_id"
            />
            <div class="club-btn-wrapper">
                <button
                    class="btn btn-full"
                    :class="{disabled: !form.club_id || isDisabledBtn}"
                    :disabled="!form.club_id || isDisabledBtn"
                    @click="createUser"
                >
                    Зарегистрироваться
                </button>
            </div>
        </div>

        <div class="fitbase-login_form--errors">
            <ul>
                <li v-for="error in form.errors" :key="error">
                    {{ error }}
                </li>
            </ul>
        </div>

        <!-- Модалка с предложением следующего способа авторизации -->
        <div v-if="showMethodModal" class="fitbase-auth-method-modal" @click.self="cancelAnotherMethod">
            <div class="fitbase-auth-method-modal__card">
                <div class="fitbase-auth-method-modal__icon-wrap">
                    <img src="../assets/img/login.svg" alt="" class="fitbase-auth-method-modal__icon">
                </div>
                <h3 class="fitbase-auth-method-modal__title">{{ nextMethodInfo && nextMethodInfo.title }}</h3>
                <p class="fitbase-auth-method-modal__text">{{ nextMethodInfo && nextMethodInfo.description }}</p>
                <button type="button" class="fitbase-auth-method-modal__btn fitbase-auth-method-modal__btn--primary" @click="confirmAnotherMethod">Продолжить</button>
                <button type="button" class="fitbase-auth-method-modal__btn fitbase-auth-method-modal__btn--cancel" @click="cancelAnotherMethod">Отменить</button>
            </div>
        </div>

    </div>
</template>

<script>
    import Datepicker from '@vuepic/vue-datepicker';
    import '@vuepic/vue-datepicker/dist/main.css'
    import { VueTelInput } from 'vue-tel-input'
    import 'vue-tel-input/dist/vue-tel-input.css'
    import ClubList from "@/components/ClubList.vue";
    import api from "@/api";
    import telegramIcon from '../assets/img/telegram.svg'
    import maxIcon from '../assets/img/max.svg'

    const TEST_PHONE = '75555555555'
    const FALLBACK_PREFERRED_COUNTRIES = ['RU', 'BY', 'KZ', 'UZ', 'KG', 'AM', 'AZ', 'TJ', 'GE', 'ID']

    export default {
        name: "AuthForm",
        components: {ClubList, Datepicker, VueTelInput },
        props: {
            redirectOnSuccess: { type: Boolean, default: true },
        },
        emits: ['authenticated', 'no_client'],
        data() {
            return {
                activeForm: 'phone',
                info: null,
                form: {
                    phone : '',
                    code : '',
                    surname : '',
                    name : '',
                    birth_date : '',
                    club_id: null,
                },
                phoneInputRaw: '',
                phoneValid: false,
                currentDialCode: '',
                phoneInputOptions: { placeholder: 'Ваш телефон' },
                clubs: [],
                errors: [],
                need_client: false,
                token: '',
                timer: 60,
                send_again: false,
                isDisabledBtn: false,
                phoneToCall: null,
                callGateId: null,
                callGateServiceType: null,
                checkCallGateAuthInterval: null,
                countDownTimeout: null,
                // Текущий метод авторизации, возвращённый сервером в actionAuth (sms / call_password / call_gate / whatsapp / auth_bots).
                activeAuthType: null,
                // Для auth_bots: список ссылок на ботов [{type, link, deeplink_token}, ...]
                bots: [],
                checkBotInterval: null,
                botWaiting: false,
                // Если пользователь явно выбрал способ входа (передаётся как auth_type на сервер).
                forcedAuthType: null,
                // Метод, который пытались использовать в последний запрос (для вычисления "следующего" при ошибке).
                lastAttemptedAuthType: null,
                // Модалка выбора следующего способа входа.
                showMethodModal: false,
                nextMethodCandidate: null,
            }
        },
        computed: {
            authType: function () {
                try {
                    return this.$store.getters.settings.modules.auth.type
                }catch (e) {
                    return ''
                }
            },
            authOrder: function () {
                const order = this.$store.getters.settings?.modules?.auth?.auth_order
                return Array.isArray(order) && order.length ? order : []
            },
            defaultCountry() {
                const code = this.$store.getters.settings?.widget?.defaultCountry
                return String(code || 'RU').toUpperCase()
            },
            preferredCountries() {
                const fromSettings = this.$store.getters.settings?.widget?.preferredCountries
                const list = Array.isArray(fromSettings) && fromSettings.length
                    ? fromSettings.map((code) => String(code).toUpperCase())
                    : FALLBACK_PREFERRED_COUNTRIES.slice()
                const priority = this.defaultCountry
                return [priority, ...list.filter((code) => code !== priority)]
            },
            hasAuthError: function () {
                return Array.isArray(this.form.errors) ? this.form.errors.length > 0 : Boolean(this.form.errors)
            },
            nextMethodInfo: function () {
                const labels = {
                    sms:           { title: 'Авторизация по коду из SMS',       description: 'Пришлем код в SMS. Продолжить?' },
                    call_password: { title: 'Авторизация по входящему звонку',  description: 'Позвоним вам и попросим указать последние 4 цифры номера' },
                    call_gate:     { title: 'Авторизация по исходящему звонку', description: 'Попросим вас позвонить на номер, это абсолютно бесплатно' },
                    whatsapp:      { title: 'Авторизация по коду из WhatsApp',  description: 'Пришлем сообщение с кодом в WhatsApp. Продолжить?' },
                    auth_bots:     { title: 'Авторизация через бота',           description: 'Попросим вас перейти в Telegram или MAX и подтвердить вход' },
                }
                const type = this.nextMethodCandidate
                return type ? (labels[type] || { title: type, description: '' }) : null
            },
            isBotAuthType: function () {
                return this.activeAuthType === 'auth_bots'
            },
            codeHint: function () {
                switch (this.activeAuthType) {
                    case 'call_password':
                        return 'Последние 4 цифры входящего номера'
                    case 'whatsapp':
                        return 'Код из сообщения'
                    case 'sms':
                    default:
                        return 'Код из SMS'
                }
            },
            phoneNoticeText: function () {
                switch (this.activeAuthType) {
                    case 'call_password':
                        return `Звонок на ${this.form.phone}`
                    case 'whatsapp':
                        return `Отправили в WhatsApp на ${this.form.phone}`
                    case 'sms':
                    default:
                        return `Отправили на ${this.form.phone}`
                }
            },
            agreeParts: function () {
              try {
                let settings = this.$store.getters.documentsModules;

                let consent = settings?.consent_personal_data;
                let personalData = settings?.processing_personal_data;
                let offer = settings?.offer;
                let clubRules = settings?.club_rules;

                return {
                  consent: {
                    label: 'согласие',
                    href: consent?.enable === true ? this.sanitizeExternalUrl(consent.link) : ''
                  },
                  personalData: {
                    label: 'обработку персональных данных',
                    href: personalData?.enable === true ? this.sanitizeExternalUrl(personalData.link) : ''
                  },
                  offer: {
                    label: 'Офертой',
                    href: offer?.enable === true ? this.sanitizeExternalUrl(offer.link) : ''
                  },
                  clubRules: {
                    label: 'Правилами клуба',
                    href: clubRules?.enable === true ? this.sanitizeExternalUrl(clubRules.link) : ''
                  }
                };
              } catch (e) {
                return {
                  consent: {label: 'согласие', href: ''},
                  personalData: {label: 'обработку персональных данных', href: ''},
                  offer: {label: 'Офертой', href: ''},
                  clubRules: {label: 'Правилами клуба', href: ''},
                };
              }
            },
        },
        watch: {
            'form.code'() {
                const inputs = document.querySelectorAll('.code_input')
                inputs.forEach(item => {
                    item.classList.remove('active')

                    if (item.value !== ''){
                        item.classList.add('active')
                    }
                })

                if (this.form.code.toString().length === 4){
                    this.checkAuth();
                }
            },
            phoneInputRaw(val) {
                if (typeof val === 'string' && val.charAt(0) === '8' && this.currentDialCode === '7') {
                    this.phoneInputRaw = '+7' + val.slice(1)
                }
            },
        },
        beforeUnmount() {
            this.clearCheckCallGateAuthInterval();
            this.clearCheckBotInterval();
            this.clearCountDownTimeout();
        },
        methods: {
            onPhoneValidate(phone) {
                // Тестовый номер не проходит проверку libphonenumber, но должен пропускаться
                const isTestPhone = `${phone?.countryCallingCode}${phone?.nationalNumber}` === TEST_PHONE
                this.phoneValid = !!phone?.valid || isTestPhone
                this.form.phone = this.phoneValid
                    ? `+${phone.countryCallingCode}${phone.nationalNumber}`
                    : ''
            },
            onPhoneCountryChanged(country) {
                this.currentDialCode = country?.dialCode || ''
            },
            async bootstrapAuthenticatedUser() {
                this.$store.commit('SET_TOKEN', this.token)
            },
            clearCheckCallGateAuthInterval() {
                if (this.checkCallGateAuthInterval) {
                    clearInterval(this.checkCallGateAuthInterval);
                    this.checkCallGateAuthInterval = null;
                }
            },
            clearCheckBotInterval() {
                if (this.checkBotInterval) {
                    clearInterval(this.checkBotInterval);
                    this.checkBotInterval = null;
                }
            },
            onBotLoginClick() {
                this.botWaiting = true
            },
            botAuthConfig(type) {
                const configs = {
                    telegram_bot: {
                        icon: telegramIcon,
                        loginLabel: 'Войти через Telegram',
                    },
                    max_bot: {
                        icon: maxIcon,
                        loginLabel: 'Войти через MAX',
                    },
                }
                return configs[type] || { icon: null, loginLabel: 'Войти' }
            },
            clearCountDownTimeout() {
                if (this.countDownTimeout) {
                    clearTimeout(this.countDownTimeout);
                    this.countDownTimeout = null;
                }
            },
            sanitizeExternalUrl(url) {
                if (!url || typeof url !== 'string') {
                    return '';
                }

                try {
                    const parsed = new URL(url, window.location.origin);

                    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
                        return '';
                    }

                    return parsed.toString();
                } catch (error) {
                    return '';
                }
            },
            persistAuthToken(token, notify = true) {
                localStorage.setItem('fitbase_token', token)
                if (!notify) {
                    return
                }
                window.dispatchEvent(new CustomEvent('fitbase-auth-changed', {
                    detail: {
                        token
                    }
                }))
            },
            async sendPhone(){
                if (!this.phoneValid || !this.form.phone) {
                    return
                }
                this.isDisabledBtn = true
                this.errors = []
                this.form.errors = []
                this.clearCheckCallGateAuthInterval();
                this.clearCheckBotInterval();
                this.botWaiting = false
                this.bots = []
                this.activeAuthType = null
                this.lastAttemptedAuthType = this.forcedAuthType || (this.authOrder[0] ?? null)
                try {
                    const payload = { phone: this.form.phone }
                    if (this.forcedAuthType) payload.auth_type = this.forcedAuthType
                    const data = (await this.$api.auth.authV2(payload)).data;

                    const isCodeSent = data.status === 'code_send'
                        || data.status === 'code send'
                        || data.success === true
                    if (isCodeSent) {
                        this.activeAuthType = data.auth_type || 'sms'
                        this.activeForm = 'code'
                        this.form.code = ''

                        if (this.activeAuthType === 'call_gate' && data.call_data) {
                            this.phoneToCall = data.call_data.phone
                            this.callGateId = data.call_data.id
                            this.callGateServiceType = data.call_data.service_type || null
                            this.checkCallGateAuthInterval = setInterval(() => {
                                this.checkAuth()
                            }, 5000)
                        } else if (this.isBotAuthType) {
                            this.bots = Array.isArray(data.bots) ? data.bots : []
                            this.checkBotInterval = setInterval(() => {
                                this.checkAuth()
                            }, 5000)
                        } else {
                            // sms / call_password / whatsapp — ждём ручной ввод кода + таймер на повтор
                            this.clearCountDownTimeout()
                            this.timer = 60
                            this.send_again = false
                            this.countDownTimer()
                        }
                    }

                    this.errorHandler(data)
                } catch (error) {
                    this.errorHandler(error)
                }
            },
            resendCode() {
                // То же, что повторный sendPhone, но сохраняем уже выбранный auth_type
                this.forcedAuthType = this.activeAuthType
                this.sendPhone()
            },
            chooseAnotherMethod() {
                // Открываем модалку с предложением следующего способа из auth_order.
                const order = this.authOrder
                if (!order.length) return
                // "Последняя попытка" приоритетнее: после ошибки activeAuthType может остаться от
                // предыдущего успешного шага и испортить вычисление следующего метода.
                const ref = this.lastAttemptedAuthType || this.activeAuthType
                const idx = ref ? order.indexOf(ref) : -1
                const next = idx === -1 ? order[0] : order[(idx + 1) % order.length]
                this.nextMethodCandidate = next
                this.showMethodModal = true
            },
            cancelAnotherMethod() {
                this.showMethodModal = false
                this.nextMethodCandidate = null
            },
            async confirmAnotherMethod() {
                const next = this.nextMethodCandidate
                this.showMethodModal = false
                this.nextMethodCandidate = null
                if (!next) return
                this.clearCheckCallGateAuthInterval()
                this.clearCheckBotInterval()
                this.clearCountDownTimeout()
                this.phoneToCall = null
                this.callGateId = null
                this.callGateServiceType = null
                this.bots = []
                this.form.code = ''
                this.errors = []
                this.form.errors = []
                this.forcedAuthType = next
                await this.sendPhone()
            },
            async checkAuth(){
                this.isDisabledBtn = true
                this.errors = []
                try {
                    let data;
                    if (this.activeAuthType === 'call_gate') {
                        const callGatePayload = {
                            phone: this.form.phone,
                            integration_id: this.callGateId,
                        }
                        if (this.callGateServiceType) {
                            callGatePayload.integration_service = this.callGateServiceType
                        }
                        data = (await this.$api.auth.checkAuthCallGate(callGatePayload)).data;
                    } else if (this.isBotAuthType) {
                        data = await this.checkBotsSessions();
                        // ни одна из сессий ботов пока не подтверждена, продолжаем ждать
                        if (!data) {
                            this.isDisabledBtn = false
                            return
                        }
                    } else {
                        data = (await this.$api.auth.authV2({
                            phone: this.form.phone,
                            code: this.form.code,
                            auth_type: this.activeAuthType || undefined,
                        })).data;
                    }

                    if (data.status === 'authorize'){
                        this.clearCheckCallGateAuthInterval();
                        this.clearCheckBotInterval();

                        this.token = data.token;

                        // Нужен ли клиент
                        this.need_client = Boolean(data.no_client);

                        if (this.need_client && !this.redirectOnSuccess) {
                            // Модальный контекст: клиент не создан — передаём управление наверх
                            // Не устанавливаем токен в store: parent создаст клиента и только потом вызовет SET_TOKEN
                            // чтобы App.vue не вызвал loadUser раньше времени (до создания клиента)
                            this.$emit('no_client', { phone: this.form.phone, token: this.token })
                        } else if (this.need_client) {
                            // Для нового пользователя на странице логина сохраняем токен "тихо":
                            // регистрация клиента должна завершиться до глобального SET_TOKEN/loadUser.
                            this.persistAuthToken(data.token, false)
                            const clubId = this.$route ? this.$route.query.club_id : null;
                            await this.loadClubs();
                            if (clubId && this.clubs.some(club => club.id === Number(clubId))) {
                                this.form.club_id = clubId;
                            }
                            this.activeForm = 'registration'
                        } else {
                            this.persistAuthToken(data.token)
                            await this.bootstrapAuthenticatedUser()
                            this.$emit('authenticated')

                            if (this.redirectOnSuccess) {
                                const scheduleId = this.$route ? this.$route.query.schedule_id : null;
                                const clubId = this.$route ? this.$route.query.club_id : null;

                                if (scheduleId) {
                                    if (clubId) {
                                        await this.changeCurrentClub(clubId);
                                    }

                                    try {
                                      const result = await api.schedule.getSchedule(scheduleId);

                                      if (result.data && result.data.has_visit_reason) {
                                          this.$store.commit('SET_SHOP_RESERVATION_MODAL', true);
                                          this.$store.commit('SET_SHOP_RESERVATION', scheduleId);
                                          this.$router.push({ name: 'Home' });
                                      } else {
                                          this.$router.push(`/shop/schedule/${scheduleId}`);
                                      }
                                    } catch (e) {
                                      this.$router.push(`/shop/schedule/${scheduleId}`);
                                    }
                                } else {
                                    this.$router.push({ name: 'Home' });
                                }
                            }
                        }
                    }

                    this.errorHandler(data)
                } catch (error) {
                    this.errorHandler(error)
                }
            },
            // Опрашивает сессии всех выданных ботов (Telegram/MAX) и возвращает результат
            // первой подтверждённой, либо null, если все ещё в ожидании подтверждения.
            async checkBotsSessions() {
                if (!Array.isArray(this.bots) || !this.bots.length) {
                    return null
                }

                const results = await Promise.all(this.bots.map(async (bot) => {
                    try {
                        return (await this.$api.auth.checkSession({
                            phone: this.form.phone,
                            deeplink_token: bot.deeplink_token,
                        })).data
                    } catch (error) {
                        return null
                    }
                }))

                const authorized = results.find((result) => result && result.status === 'authorize')
                if (authorized) {
                    return authorized
                }

                const stillPending = results.some((result) => result && result.status === 'pending')
                if (stillPending) {
                    return null
                }

                return results.find((result) => result) || { status: 'error', error: 'Сессия истекла' }
            },
            handleRegistrationStep() {
                if (!this.form.club_id && this.clubs.length >= 2) {
                    this.activeForm = 'club';
                } else {
                    this.createUser();
                }
            },
            async createUser(){
                this.isDisabledBtn = true
                this.errors = []
                try {
                    const data = (await this.$api.auth.registration({
                        name: this.form.name,
                        surname: this.form.surname,
                        patronymic: '',
                        b_day: this.form.birth_date,
                        phone: this.form.phone,
                        club: this.form.club_id,
                    })).data;

                    if (data.id !== undefined && data.id !== null){
                        await this.bootstrapAuthenticatedUser()
                        this.$emit('authenticated')

                        if (this.redirectOnSuccess) {
                            const scheduleId = this.$route ? this.$route.query.schedule_id : null;
                            if (scheduleId) {
                                this.$router.push(`/shop/schedule/${scheduleId}`);
                            } else {
                                this.$router.push({ name: 'Home' });
                            }
                        }
                    }

                    this.errorHandler(data)
                } catch (error) {
                    this.errorHandler(error)
                }
            },
            errorHandler(data){
                if (data.error){
                    this.form.errors = Array.isArray(data.error) ? data.error : [data.error];
                }else if (data.response !== undefined && data.response.status !== 200){
                    this.form.errors = [data.response.data.message];
                }
                this.isDisabledBtn = false
            },
            countDownTimer () {
                if (this.timer > 0) {
                    this.countDownTimeout = setTimeout(() => {
                        this.timer -= 1
                        this.countDownTimer()
                    }, 1000)
                }else{
                    this.clearCountDownTimeout();
                    this.send_again = true
                    this.timer = 300
                }
            },
            async loadClubs() {
                try {
                    const response = await this.$store.dispatch('optionsClub');
                    this.clubs = response.data;

                    if (this.clubs.length === 1) {
                        this.form.club_id = this.clubs[0].id;
                    } else {
                        this.form.club_id = null;
                    }
                } catch (e) {
                    this.errors = ['Ошибка при загрузке филиалов'];
                }
            },
            async changeCurrentClub(club_id) {
              try {
                const result = await this.$api.user.changeCurrentClub(club_id);
                if (!result.data || !result.data.status == 'success') {
                  this.toast.error("Ошибка при смене филиала");
                }
              } catch (error) {
                this.toast.error("Ошибка при смене филиала");
              }
            }
        }
    }
</script>
